var _mask, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarCollapseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 35,
    viewBox: "0 0 38 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_552_578",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.206909 3.00391C0.206909 1.34705 1.55006 0.00390625 3.20691 0.00390625H34.1425C35.7993 0.00390625 37.1425 1.34705 37.1425 3.00391V31.7897C37.1425 33.4465 35.7993 34.7897 34.1425 34.7897H3.20691C1.55006 34.7897 0.206909 33.4465 0.206909 31.7897V3.00391Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.206909 3.00391C0.206909 1.34705 1.55006 0.00390625 3.20691 0.00390625H34.1425C35.7993 0.00390625 37.1425 1.34705 37.1425 3.00391V31.7897C37.1425 33.4465 35.7993 34.7897 34.1425 34.7897H3.20691C1.55006 34.7897 0.206909 33.4465 0.206909 31.7897V3.00391Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.793091 3.00391C-0.793091 0.794767 0.99777 -0.996094 3.20691 -0.996094H33.1425C35.3516 -0.996094 37.1425 0.794767 37.1425 3.00391C37.1425 1.89934 35.7993 1.00391 34.1425 1.00391H3.20691C2.10234 1.00391 1.20691 1.89934 1.20691 3.00391H-0.793091ZM37.1425 31.7897C37.1425 33.9988 35.3516 35.7897 33.1425 35.7897H3.20691C0.99777 35.7897 -0.793091 33.9988 -0.793091 31.7897H1.20691C1.20691 32.8943 2.10234 33.7897 3.20691 33.7897H34.1425C35.7993 33.7897 37.1425 32.8943 37.1425 31.7897ZM3.20691 35.7897C0.99777 35.7897 -0.793091 33.9988 -0.793091 31.7897V3.00391C-0.793091 0.794767 0.99777 -0.996094 3.20691 -0.996094V1.00391C2.10234 1.00391 1.20691 1.89934 1.20691 3.00391V31.7897C1.20691 32.8943 2.10234 33.7897 3.20691 33.7897V35.7897ZM37.1425 0.00390625V34.7897V0.00390625Z",
    fill: "#494843",
    mask: "url(#path-1-inside-1_552_578)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2475 10.7962L24.3931 17.3965L15.2475 23.9968L15.2475 10.7962Z",
    stroke: "white",
    strokeOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarCollapseIcon);
export default __webpack_public_path__ + "static/media/sidebar_collapse_icon.e09d3009d1159e6f4ea250bdba97cf69.svg";
export { ForwardRef as ReactComponent };